var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDocumentation = function SvgIconDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5047ff",
    d: "M21 15.125V3.875A1.875 1.875 0 0 0 19.125 2H7.25A3.75 3.75 0 0 0 3.5 5.75v12.5A3.75 3.75 0 0 0 7.25 22h12.5a1.213 1.213 0 0 0 .625-2.273v-3.179A1.99 1.99 0 0 0 21 15.125M9.09 7h7.5a.635.635 0 0 1 .66.625.627.627 0 0 1-.625.625H9.09a.626.626 0 0 1 0-1.25m0 2.5h7.5a.635.635 0 0 1 .66.625.627.627 0 0 1-.625.625H9.09a.626.626 0 0 1 0-1.25m9.41 10H7.25a1.25 1.25 0 0 1 0-2.5H18.5Z",
    "data-name": "Group 1787"
  })));
};
export default SvgIconDocumentation;